
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/membership/member-resources",
      function () {
        return require("private-next-pages/about/membership/member-resources.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/membership/member-resources"])
      });
    }
  